
import React from 'react';
import { useSal } from '../contexts/SalContext';
import { JarvisHUD } from './JarvisHUD';
import { GlobalModalRegistry } from './GlobalModalRegistry';
import { SofiaDecisionModal } from './SofiaDecisionModal';
import * as Sentry from '@sentry/react';

export const GlobalModals: React.FC = () => {
  const {
    intelligence: { pendingOrders, smartSplit, historicalOrders },
    actions, drivers, safeConfig, context, jarvisActions,
    modals, ui, setOrders, setAppMode, providers, setDrivers, setProviders, appMode, setConfig, storeId,
    activeModalOrder
  } = useSal();

  return (
    <>
      <Sentry.ErrorBoundary fallback={null}>
        <React.Suspense fallback={null}>
          <JarvisHUD orders={pendingOrders} drivers={drivers} config={safeConfig} context={context} logisticAnalysis={smartSplit} actions={jarvisActions} />
        </React.Suspense>
      </Sentry.ErrorBoundary>

      <Sentry.ErrorBoundary fallback={null}>
        <React.Suspense fallback={null}>
          <GlobalModalRegistry
            config={safeConfig} setConfig={setConfig} drivers={drivers} setDrivers={setDrivers}
            providers={providers} setProviders={setProviders} orders={pendingOrders} setOrders={setOrders}
            modals={modals} activeOrder={activeModalOrder} incidentOrder={activeModalOrder}
            finishedOrders={historicalOrders} appMode={appMode} onClose={(name) => actions.toggleModal(name as any, false)}
            onOrderParsed={actions.handleOrderParsed} onOrderUpdate={(updated) => actions.onOrderUpdate(updated)}
            onOrderDelete={actions.onOrderDelete} onAppModeChange={setAppMode}
            onIncidentSave={(id, inc) => setOrders(prev => prev.map(o => id === o.id ? { ...o, incidents: [...(o.incidents || []), inc] } : o))}
            onAddSangria={(did, val) => setDrivers(prev => prev.map(d => d.id === did ? { ...d, cashReturns: [...(d.cashReturns || []), { id: Date.now().toString(), driverId: did, amount: val, timestamp: Date.now() }] } : d))}
            onFinalizeDay={() => actions.onFinalizeDay()} storeId={storeId}
          />
        </React.Suspense>
      </Sentry.ErrorBoundary>

      <Sentry.ErrorBoundary fallback={null}>
        <React.Suspense fallback={null}>
          <SofiaDecisionModal
            isOpen={modals.sofiaDecision?.isOpen || false}
            onClose={ui?.closeSofiaDecision}
            onConfirm={() => {
              const { orders, strategyType } = modals.sofiaDecision || {};
              if (orders && strategyType) {
                actions.handleConfirmStrategy(orders.map((o: any) => o.id), strategyType);
              }
              modals.sofiaDecision?.onConfirm?.();
              ui?.closeSofiaDecision();
            }}
            onIgnore={(reason) => {
              const { orders, strategyType } = modals.sofiaDecision || {};
              if (orders && strategyType) {
                actions.handleIgnoreStrategy(orders.map((o: any) => o.id), strategyType, reason);
              }
              ui?.closeSofiaDecision();
            }}
            mode={modals.sofiaDecision?.mode}
            strategyType={modals.sofiaDecision?.strategyType}
            orders={modals.sofiaDecision?.orders}
            savings={modals.sofiaDecision?.savings}
            delayImpact={modals.sofiaDecision?.delayImpact}
            description={modals.sofiaDecision?.description}
            isSolarMode={safeConfig.isSolarMode}
          />
        </React.Suspense>
      </Sentry.ErrorBoundary>
    </>
  );
};
